<template>
  <div>
<!--     <markdown-pro v-model="value" :height="500" :theme="'light'"></markdown-pro> -->
  </div>
</template>

<script>
// import MarkdownPro from '@/components/markdown/pro';
export default {
  name: 'vueMarkdown',
  data () {
    return {
      value: ''
    }
  },
  components: {
    // MarkdownPro,
    // MarkdownPreview,
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/MarkdownEditor/VueMarkdown.vue